import { Controller, Loader, IDynamicLoader } from '@tencent/workbench';
import { FORM_CONFIGS, SATURATE_MAX, TEMPERATURE_MAX, TEMPERATURE_MIN } from '@framework/workbench/drawer/ui/picture/picture-color/config';
import { Form, NumberInputFrom } from '@tencent/wb-ext-form';
import { FormItemName, IMultiDiffValue, INPUT_PROPS_CALLBACK_KEY } from '@framework/workbench/drawer/constants';
import { IPictureColorFeature } from './picture-color-interface';

@Controller({ formItems: FORM_CONFIGS })
export class PictureColorController {
    constructor(@Loader(IPictureColorFeature) private loader: IDynamicLoader<IPictureColorFeature>) {}

    private get feature() {
        return this.loader.instance!;
    }

    @Form(FormItemName.PICTURE_COLOR_RESET, 'content')
    public renderReset() {
        return this.feature.renderReset();
    }

    @Form(FormItemName.PICTURE_COLOR_RESET, 'shouldDisabled')
    public shouldResetDisabled(): boolean {
        return this.feature.isGifOrSvg();
    }

    @Form(FormItemName.PICTURE_RECOLOR_TEXT, 'shouldDisabled')
    public shouldReColorTextDisabled(): boolean {
        return this.feature.isGifOrSvg();
    }

    @Form(FormItemName.PICTURE_RECOLOR, 'shouldDisabled')
    public shouldReColorDisabled(): boolean {
        return this.feature.isGifOrSvg();
    }

    @Form(FormItemName.PICTURE_RECOLOR, 'content')
    public renderReColor() {
        return this.feature.renderReColor();
    }

    @Form(FormItemName.SATURATE, 'value')
    public getSaturate(): number | IMultiDiffValue {
        return this.feature.getShownValue(
            INPUT_PROPS_CALLBACK_KEY.PICTURE_COLOR,
            { saturate: this.feature.saturate },
        );
    }

    @Form(FormItemName.SATURATE, 'onChange')
    public changeSaturate(value: number, dragEnd?: boolean, from?: NumberInputFrom): void {
        const { saturate } = this.feature.getValidValue({ saturate: value }, from, SATURATE_MAX);
        this.feature.handlePictureColorChange(saturate, 'saturate', from, dragEnd);
    }

    @Form(FormItemName.SATURATE, 'shouldDisabled')
    public shouldSaturateDisabled(): boolean {
        return this.feature.isGifOrSvg();
    }

    @Form(FormItemName.COLOR_TEMPERATURE, 'value')
    public getColorTemperature(): number | IMultiDiffValue {
        return this.feature.getShownValue(
            INPUT_PROPS_CALLBACK_KEY.PICTURE_COLOR,
            { colorTemperature: this.feature.colorTemperature },
        );
    }

    @Form(FormItemName.COLOR_TEMPERATURE, 'onChange')
    public changeColorTemperature(value: number, dragEnd?: boolean, from?: NumberInputFrom): void {
        const { colorTemperature } = this.feature.getValidValue(
            { colorTemperature: value }, from,
            TEMPERATURE_MAX, TEMPERATURE_MIN,
        );
        this.feature.handlePictureColorChange(colorTemperature, 'colorTemperature', from, dragEnd);
    }

    @Form(FormItemName.COLOR_TEMPERATURE, 'shouldDisabled')
    public shouldTemperatureDisabled(): boolean {
        return this.feature.isGifOrSvg();
    }
}
